import React from "react";

export default function PrivacyPolicy() {
  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "0 auto",
        padding: "60px 24px",
        fontFamily: "Inter, sans-serif",
        lineHeight: 1.7,
        color: "#0f172a"
      }}
    >
      <h1>Privacy Policy</h1>

      <p>
        <strong>Effective Date:</strong> May 14, 2026
      </p>

      <p>
        Smarter Student Coaching respects your privacy and is committed
        to protecting your personal information.
      </p>

      <h2>Information We Collect</h2>

      <p>We may collect:</p>

      <ul>
        <li>Parent and student names</li>
        <li>Email addresses</li>
        <li>Phone numbers</li>
        <li>School-related information</li>
        <li>Assignment and coaching information</li>
      </ul>

      <h2>How Information Is Used</h2>

      <p>Information may be used to:</p>

      <ul>
        <li>Provide coaching services</li>
        <li>Send assignment reminders and coaching texts</li>
        <li>Communicate with students and parents</li>
        <li>Improve coaching systems and support</li>
      </ul>

      <h2>Text Messaging</h2>

      <p>
        By providing your phone number, you consent to receive
        coaching-related text messages from Smarter Student Coaching.
        Message frequency varies. Message and data rates may apply.
      </p>

      <p>
        Reply STOP at any time to opt out.
      </p>

      <h2>Data Sharing</h2>

      <p>
        Smarter Student Coaching does not sell or share personal
        information with third parties for marketing purposes.
      </p>

      <h2>Contact</h2>

      <p>
        Grahme Smith
        <br />
        Smarter Student Coaching
        <br />
        grahme@smarterstudentcoaching.com
      </p>
    </div>
  );
}